// extracted by mini-css-extract-plugin
export var fileUpload = "_dm-1";
export var modalButton = "_dm-0";